import React, { Component } from 'react';
import { observer } from "mobx-react";

class Error extends Component {
/*  constructor(props) {
    super(props);
  }
  componentWillMount() {
    setTimeout(()=>{
      this.props.deleteMe();
    },5000);
  }*/
  render() {
    return (
      <div className="ofh">
        <div className="pr" style={{width:320}}>
          <div className="padd10 w1 bg-const2">
            {this.props.str}
          </div>
          <div className="pbottom10"></div>
        </div>
      </div>
    )
  }
}

export default observer(Error);
